module.exports = __webpack_public_path__ + "img/Refuel Petrol.7dad5dd3.png";